import React from 'react'
import styled from 'styled-components'
import FaTwitter from 'react-icons/lib/fa/twitter'
import FaFacebook from 'react-icons/lib/fa/facebook'
import FaLinkedin from 'react-icons/lib/fa/linkedin'
import FaSnapchat from 'react-icons/lib/fa/snapchat'
import FaInstagram from 'react-icons/lib/fa/instagram'

const HEIGHT = '480px'
const WIDTH = '320px'
const BORDER_RADIUS = '10px'

const Wrapper = styled.div`
  @import url(https://fonts.googleapis.com/css?family=Roboto);

  font-family: "Roboto", sans-serif;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
  * {
    outline: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
`

const FlipContainer = styled.div`
  cursor: pointer;
  margin: 0 auto;
  -webkit-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
  border-radius: ${BORDER_RADIUS};
  width: ${WIDTH};
  height: ${HEIGHT};
  
  &.flip .flipper {
    -webkit-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
  }
`

const Flipper = styled.div`
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  position: relative;
`

const Front = styled.div`
  background: #e86161;
  border: 1px solid #dbdbdb;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fafafa;
  border-radius: ${BORDER_RADIUS};
  width: ${WIDTH};
  height: ${HEIGHT};
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: -1; // firefox backface-visibility fix
  position: absolute;
  top: 0;
  left: 0;
    
  img {
    max-height: 250px;
    max-width: 250px;
  }
`

const Back = styled.div`
  background: #fff;
  border: 1px solid #dbdbdb;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.15);
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  color: #555;
  border-radius: ${BORDER_RADIUS};
  width: ${WIDTH};
  height: ${HEIGHT};
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
    
  img {
    border: 7px solid rgba(255, 255, 255, 0.5);
    width: 150px;
    border-radius: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5rem;
  }
  
  h1 {
    margin-bottom: 0;
    margin-left: 1rem;
  }
  
  h2 {
    margin-top: 0.5rem;
    font-size: 1.25rem;
    margin-left: 1rem;
  }
`

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
`

const HorizontalList = styled(List)`
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-size: 1.2rem;
  margin-top: 1rem;
`

const Link = styled.a.attrs({
  target: '_blank'
})`
  color: #555;
  text-decoration: none;
`

const SocialLink = styled(Link)`
  padding: 1rem;
`

const Item = styled.li`
  padding: .5rem 1rem;
`

const Help = styled.div`
  color: #a1a1a1;
  text-align: center;
`

const isLink = node => node.tagName === 'path' || node.tagName === 'A' || node.parentElement.tagName === 'path' || node.parentElement.tagName === 'A'

class FlippingCardTemplate extends React.PureComponent {

  _onTouchStart = e => {
    if (isLink(e.target)) return // do not flip on link click
    this.flipContainer.classList.toggle('hover')
  }

  _onClick = e => {
    if (isLink(e.target)) return // do not flip on link click
    this.flipContainer.classList.toggle('flip')
  }

  render () {
    const {frontImage, frontText, backImage, backName, backWebsite, backEmail, backTitle, facebookLink, twitterLink, snapchatLink, linkedinLink, instagramLink} = this.props
    return (
      <Wrapper>

        <Container>
          <FlipContainer id='flip-container' innerRef={ref => this.flipContainer = ref} onTouchStart={this._onTouchStart} onClick={this._onClick}>
            <Flipper className='flipper'>

              <Front>
                <img src={frontImage} alt='business card logo' />
                {frontText && <h1>{frontText}</h1>}
              </Front>

              <Back>
                <img src={backImage} alt='business card avatar' />
                {backName && <h1>{backName}</h1>}
                {backTitle && <h2>{backTitle}</h2>}
                <List>
                  {backWebsite && <Item><Link href={`https://${backWebsite}`}>{backWebsite}</Link></Item>}
                  {backEmail && <Item><Link href={`mailto:${backEmail}?Subject=Hello%20from%20from%20my%20virtual%20business%20card`}>{backEmail}</Link></Item>}
                </List>
                <HorizontalList>
                  {facebookLink && <li><SocialLink href={facebookLink}><FaFacebook /></SocialLink></li>}
                  {twitterLink && <li><SocialLink href={twitterLink}><FaTwitter /></SocialLink></li>}
                  {linkedinLink && <li><SocialLink href={linkedinLink}><FaLinkedin /></SocialLink></li>}
                  {snapchatLink && <li><SocialLink href={snapchatLink}><FaSnapchat /></SocialLink></li>}
                  {instagramLink && <li><SocialLink href={instagramLink}><FaInstagram /></SocialLink></li>}
                </HorizontalList>
              </Back>

            </Flipper>
          </FlipContainer>
        </Container>

        <Help id='attribution'>
          <p>Tap card to flip it</p>
        </Help>

      </Wrapper>
    )
  }
}

export default FlippingCardTemplate